export default __webpack_public_path__ + "static/media/ed-pastor-at-pakistan-mobile-size.06d10d79.jpg";